"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var authFields_1 = __importDefault(require("./authFields"));
var ST = __importStar(require("./styled"));
var baseButton_1 = require("../../buttons/baseButton");
var NoAuth = function (_a) {
    var withoutMargin = _a.withoutMargin, sendEvent = _a.sendEvent, openChat = _a.openChat, openCitySelect = _a.openCitySelect, authSubmit = _a.authSubmit, loginMessage = _a.loginMessage, cities = _a.cities, city = _a.city, changeStateModalWindow = _a.changeStateModalWindow;
    return (react_1.default.createElement(ST.NoAuthWrapper, { withoutMargin: withoutMargin },
        react_1.default.createElement(ST.AuthBlock, null,
            react_1.default.createElement(authFields_1.default, { "data-test": 'auth-fields', sendEvent: sendEvent, buttonText: '\u0412\u043E\u0439\u0442\u0438', showCheckBox: true, showForgetLink: true, authSubmit: authSubmit, loginMessage: loginMessage, cities: cities, city: city, openChat: openChat, openCitySelect: openCitySelect }),
            react_1.default.createElement(ST.GreyText, null,
                "\u041D\u0430\u0436\u0438\u043C\u0430\u044F \u043A\u043D\u043E\u043F\u043A\u0443 \u00AB\u0412\u043E\u0439\u0442\u0438\u00BB, \u0432\u044B \u0434\u0430\u0435\u0442\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443 ",
                react_1.default.createElement(ST.GreyLink, { as: 'a', href: 'https://tcenter.ru/voprosy-i-otvety/dogovory-i-dokumenty/', target: '_blank' }, "\u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(baseButton_1.BaseButton, { block: true, onClick: changeStateModalWindow, type: baseButton_1.btnTypes.SECONDARY, text: '\u0421\u0442\u0430\u0442\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u043C' })))));
};
exports.default = NoAuth;
